import React from 'react';
import './style.scss';
import useEditUserProfile from './hooks';
import Form from '../../../components/molecules/forms';
import FormFooter from '../../../components/layout/footer/form';
import AddHeader from '../../../components/layout/header/add';

function EditUserProfile() {
  const {
    formikCompany, formikLogin, formikPersonal, isLoading,
  } = useEditUserProfile();
  return (
    <div>
      <AddHeader
        primary={{ route: '/overview', title: 'Overview' }}
        title="Edit Profile Details"
      />
      <form onSubmit={formikLogin.handleSubmit}>
        <div className="px-4 px-xl-5">
          <div className="fw-bold fz-14 mb-4" style={{ marginLeft: '20px' }}>
            Edit User Login Details
          </div>
          <Form.Default
            id="username"
            placeholder="Enter Username"
            label="Username"
            className="mb-4"
            value={formikLogin.values.username}
            onChange={formikLogin.handleChange}
            onBlur={formikLogin.handleBlur}
            readOnly
          />
          <div className="row">
            <div className="col-lg-4">
              <Form.Default
                id="currentPassword"
                placeholder="Enter Current Password"
                label="Current Password"
                className="mb-4"
                value={formikLogin.values.currentPassword}
                onChange={formikLogin.handleChange}
                // isInvalid={!!formikLogin.errors.currentPassword && formikLogin.touched.currentPassword}
                // errorMsg={formikLogin.errors.currentPassword}
                onBlur={formikLogin.handleBlur}
                type="password"
              />
            </div>
            <div className="col-lg-4">
              <Form.Default
                id="newPassword"
                placeholder="Enter New Password"
                label="New Password"
                className="mb-4"
                value={formikLogin.values.newPassword}
                onChange={formikLogin.handleChange}
                isInvalid={!!formikLogin.errors.newPassword && formikLogin.touched.newPassword}
                errorMsg={formikLogin.errors.newPassword}
                onBlur={formikLogin.handleBlur}
                type="password"
              />
            </div>
            <div className="col-lg-4">
              <Form.Default
                id="confirmPassword"
                placeholder="Confirm New Password"
                label="Confirm New Password"
                className="mb-4"
                value={formikLogin.values.confirmPassword}
                onChange={formikLogin.handleChange}
                isInvalid={!!formikLogin.errors.confirmPassword && formikLogin.touched.confirmPassword}
                errorMsg={formikLogin.errors.confirmPassword}
                onBlur={formikLogin.handleBlur}
                type="password"
              />
            </div>
          </div>
        </div>
        <FormFooter
          submitText="Update Password"
          isLoading={isLoading.initial || isLoading.password}
        />
      </form>
      <div className="w-100 bg-stroke mb-4" style={{ height: '7px' }} />
      <form onSubmit={formikPersonal.handleSubmit}>
        <div className="px-4 px-xl-5">
          <div className="fw-bold fz-14 mb-4" style={{ marginLeft: '20px' }}>
            Edit Personal Info Details
          </div>
          <div className="row">
            <div className="col-lg-6">
              <Form.Default
                id="firstname"
                placeholder="Enter First Name"
                label="First Name"
                className="mb-4"
                value={formikPersonal.values.firstname}
                onChange={formikPersonal.handleChange}
                isInvalid={!!formikPersonal.errors.firstname && formikPersonal.touched.firstname}
                errorMsg={formikPersonal.errors.firstname}
                onBlur={formikPersonal.handleBlur}
                disabled={isLoading.initial}
              />
            </div>
            <div className="col-lg-6">
              <Form.Default
                id="lastname"
                placeholder="Enter Last Name"
                label="Last Name"
                className="mb-4"
                value={formikPersonal.values.lastname}
                onChange={formikPersonal.handleChange}
                isInvalid={!!formikPersonal.errors.lastname && formikPersonal.touched.lastname}
                errorMsg={formikPersonal.errors.lastname}
                onBlur={formikPersonal.handleBlur}
                disabled={isLoading.initial}
              />
            </div>
          </div>
          <Form.Default
            id="phoneNumber"
            placeholder="Enter Phone Number"
            label="Phone Number"
            className="mb-4"
            value={formikPersonal.values.phoneNumber}
            onChange={formikPersonal.handleChange}
            isInvalid={!!formikPersonal.errors.phoneNumber && formikPersonal.touched.phoneNumber}
            errorMsg={formikPersonal.errors.phoneNumber}
            onBlur={formikPersonal.handleBlur}
            disabled={isLoading.initial}
          />
          <Form.Default
            id="position"
            placeholder="Enter Position"
            label="Position"
            className="mb-4"
            value={formikPersonal.values.position}
            onChange={formikPersonal.handleChange}
            isInvalid={!!formikPersonal.errors.position && formikPersonal.touched.position}
            errorMsg={formikPersonal.errors.position}
            onBlur={formikPersonal.handleBlur}
            disabled={isLoading.initial}
          />
        </div>
        <FormFooter
          submitText="Update Info"
          isLoading={isLoading.initial || isLoading.personal}
        />
      </form>
      <div className="w-100 bg-stroke mb-4" style={{ height: '7px' }} />
      <div className="px-4 px-xl-5 pb-5">
        <div className="fw-bold fz-14 mb-4" style={{ marginLeft: '20px' }}>
          Company Info Details
        </div>
        <Form.Default
          id="name"
          placeholder="Enter Company Name"
          label="Company Name"
          className="mb-4"
          value={formikCompany.values.name}
          onChange={formikCompany.handleChange}
          // isInvalid={!!formikCompany.errors.name && formikCompany.touched.name}
          // errorMsg={formikCompany.errors.name}
          onBlur={formikCompany.handleBlur}
          readOnly
        />
        <Form.Default
          id="streetAddress"
          placeholder="Enter Street Address"
          label="Company Name"
          className="mb-4"
          value={formikCompany.values.streetAddress}
          onChange={formikCompany.handleChange}
          // isInvalid={!!formikCompany.errors.streetAddress && formikCompany.touched.streetAddress}
          // errorMsg={formikCompany.errors.streetAddress}
          onBlur={formikCompany.handleBlur}
          readOnly
        />
        <div className="row">
          <div className="col-lg-6">
            <Form.Default
              id="city"
              placeholder="Enter City"
              label="City"
              className="mb-4"
              value={formikCompany.values.city}
              onChange={formikCompany.handleChange}
              // isInvalid={!!formikCompany.errors.city && formikCompany.touched.city}
              // errorMsg={formikCompany.errors.city}
              onBlur={formikCompany.handleBlur}
              readOnly
            />
          </div>
          <div className="col-lg-6">
            <Form.Default
              id="state"
              placeholder="Enter State"
              label="State"
              className="mb-4"
              value={formikCompany.values.state}
              onChange={formikCompany.handleChange}
              // isInvalid={!!formikCompany.errors.state && formikCompany.touched.state}
              // errorMsg={formikCompany.errors.state}
              onBlur={formikCompany.handleBlur}
              readOnly
            />
          </div>
        </div>
        <Form.Default
          id="zipCode"
          placeholder="Enter Zip Code"
          label="Zip Code"
          className="mb-4"
          value={formikCompany.values.zipCode}
          onChange={formikCompany.handleChange}
          // isInvalid={!!formik.errors.zipCode && formik.touched.zipCode}
          // errorMsg={formik.errors.zipCode}
          onBlur={formikCompany.handleBlur}
          type="number"
          readOnly
        />
      </div>
    </div>
  );
}

export default EditUserProfile;
